<template>
    <el-dialog title="Documentos del Resumen"
        :visible.sync="showModalDocuments"
        width="40%"
        @open="fetchDocuments"
        @close="closeModal"
    >
        <div class="row" v-loading="loading">
            <div class="col-12"
                v-for="(document, index) in documents"
                :key="index"
            >
                {{ document }}
            </div>
        </div>
    </el-dialog>
</template>

<script>
export default {
    props: ['showModalDocuments', 'summaryId'],

    data() {
        return {
            loading: false,
            documents: []
        }
    },

    methods: {
        async fetchDocuments() {
            this.loading = true
            try {
                const response = await this.$http.get(`/summaries/documents-related/${this.summaryId}`)
                if (response.data.success) {
                    this.documents = response.data.data
                } else {
                    this.$message.error('Error al cargar los documentos relacionados.')
                }
            } catch (error) {
                this.$message.error('Error en la solicitud.')
            } finally {
                this.loading = false
            }
        },

        closeModal() {
            this.$emit('update:showModalDocuments', false)
            this.documents = []
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/js/views/tenant/summaries/partials/ModalDocuments.vue